import React from "react";
import { Button } from "react-bootstrap";

interface IProps {
    /** True when the current quote has no COMP/COLL selected (liability only). */
    isLiabilityOnly: boolean;
    onYes: () => void;
    disabled?: boolean;
}

/**
 * Req #7/#9: blue info box (same style as the payment-plans footer).
 * Offers the opposite package; Yes re-rates LO ↔ full coverage ($1,000).
 */
const AlternateCoverageBanner: React.FC<IProps> = ({ isLiabilityOnly, onYes, disabled }) => {
    const currentLabel = isLiabilityOnly ? "liability only" : "full coverage";
    const alternateLabel = isLiabilityOnly ? "full coverage" : "liability only";

    return (
        <div className="payment-info-footer d-flex align-items-center p-3 mt-3">
            <div className="info-footer-icon-container mr-3">
                <i className="fas fa-shield-alt text-muted"></i>
            </div>
            <div className="info-footer-text">
                <div>
                    This is a {currentLabel} quote, would you like to quote for a {alternateLabel} instead?
                </div>
                <div className="mt-2">
                    <Button size="sm" variant="primary" className="text-white" onClick={onYes} disabled={disabled}>
                        Yes
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AlternateCoverageBanner;
